"use client";
import { jsx } from "react/jsx-runtime";
import { Form as Form$1 } from "react-aria-components";
var Form = ({ ref: n,...r }) => /* @__PURE__ */ jsx(Form$1, {
	ref: n,
	...r
});
export { Form };
